import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FlowChartDataService} from '../../../services/flow-chart-data.service';
import {Observable, Subject} from 'rxjs';
import {IConfigureWizard} from '@shared/interfaces/workflow-step.interface';
import {take, takeUntil} from 'rxjs/operators';
import {getCurrentSurvey} from '../../../store/selectors/data-survey.selectors';
import {select, Store} from '@ngrx/store';
import {DataSurveyState} from '../../../store/reducers/data-survey.reducers';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {QueryProvider} from '@shared/queries/query-provider';
import {ActivatedRoute, Router} from '@angular/router';
import {GetSurveyAction} from '../../../store/actions/data-survey.actions';
import {Guid} from 'guid-typescript';
import {CommandService} from '@core/services/command.service';
import {SyncFieldsInDataSurveyCommand} from '../../../commands/survey.commands';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { FuseSidebarService } from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformCommand} from '@shared/commands/command-base';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import { BreadcrumbBar, MagicLinkModel, ToolbarModel } from '@shared/models/platform-tool-models';
import {
  SetCurrentRightSideBarFoldOrNotAction,
  SetCurrentRightSideComponentAction
} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {DetailsInstructionService, InstructionDetailsSourceViewType} from '@shared/services/details-instruction-service';
import {getCurrentRightSideComponentInfo} from "@shared/components/platform-sidebar/store/platform-sidebar.selector";
import {PlatformSidebarService} from "@shared/components/platform-sidebar/store/platform-sidebar.service";


@Component({
    standalone: false,
    selector: 'particle-flow-chart-container',
  templateUrl: './flow-chart-container.component.html',
  styleUrls: ['./flow-chart-container.component.scss']
})
export class FlowChartContainerComponent implements OnInit, OnDestroy {
  @Input() flowChartId: string;
  @Input() surveyId: string;
  @Input() surveyExecutionId: string;
  @Input() itemId: string;
  @Input() sourceType: string;
  @Input() hideFlowchartTabs: boolean;
  defaultExpansionPanelIndex : number;
  isReady: boolean = false;
  sections: any[] = [];
  currentRightSideComponentInfo: any;
  survey: any;
  selectedTabIndex: number = 0;
  flowcharts: any = [];
  flowchartSections: any = {};
  ngUnsubscribe = new Subject<void>();
  breadcrumbs: BreadcrumbModel[];
  flowChartMode: string = 'design';
  rowItem: any;
  fieldDefinitions: any;
  isResponseView: boolean = false;
  isManageFields: boolean = false;
  manageFieldsBreadcrumbs$: Observable<any>;
  magicLinkModel: MagicLinkModel;
  breadcrumbBar: BreadcrumbBar;
  toolbar: ToolbarModel;
  toolHeader: string;
  constructor(
    private fuseSplashScreenService: FuseSplashScreenService,
    private dialogService: DialogService,
    private commandService: CommandService,
    private router: Router,
    public flowChartDataService: FlowChartDataService,
    private dataSurveyStore: Store<DataSurveyState>,
    private activatedRoute: ActivatedRoute,
    private queryStore: Store<IQueryState>,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private sidebarService: FuseSidebarService,
    private detailsInstructionService: DetailsInstructionService,
    private platformSidebarService: PlatformSidebarService,
  ) {
    this.flowChartDataService.excludeHiddenQuestions = true;
    this.defaultExpansionPanelIndex = 0;
    this.flowChartDataService.setResponseExecutionId(Guid.create().toString());
    this.flowChartDataService.initFlowchartData();
    this.isReady = false;
  }

  ngOnInit() {
    this.platformSidebarStore.select(getCurrentRightSideComponentInfo).pipe(takeUntil(this.ngUnsubscribe)).subscribe(currentRightSideComponentInfo => {
      this.currentRightSideComponentInfo = currentRightSideComponentInfo;
    });
    this.flowChartDataService.setFlowchartId(this.flowChartId); // comes @Input() from response mode
    if (this.surveyId) {
      // when set  @Input() surveyId comes from survey response
      this.createDataSurveyBreadcrumbs();
      this.flowChartDataService.surveyId = this.surveyId;
      if (this.surveyExecutionId) {
        this.isResponseView = true;
        this.flowChartDataService.setResponseExecutionId(this.surveyExecutionId);
        this.flowChartMode = 'response';
        this.getCurrentSurvey();
        this.isReady = true;
      }
    } else {
      this.activatedRoute.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: any) => {
        if (params.magicLinkId) {
          this.flowChartDataService.fetchMagicLink(params.magicLinkId).then(
            magicLinkModel => {
              this.magicLinkModel = magicLinkModel;
              this.breadcrumbBar = this.magicLinkModel.breadcrumbBar;
              this.toolbar = this.magicLinkModel.toolbar;
              console.log('Magic Link', magicLinkModel);
              this.isReady = true;
              if (this.magicLinkModel.fieldValues['SourceType']) {
                this.flowChartDataService.setApi(this.magicLinkModel.breadcrumbBar.breadcrumbs[0].api);
                this.sourceType = this.magicLinkModel.fieldValues['SourceType'];
                this.flowChartId = this.magicLinkModel.fieldValues['FlowchartId'];
                this.flowChartDataService.setFlowchartId(this.flowChartId);
                this.isManageFields = true;
                this.flowChartDataService.setSourceType(this.sourceType);
                this.flowChartDataService.fetchCustomDataTypes(this.sourceType);
                this.flowChartDataService.setIsManageFields(true);


                this.fetchDesignerAllTopics();
              }
            }
            ,
            error => {
              console.error('flowchart get sections error', error);
            }
          );
        } else if (params.surveyId) {
          // comes from survey template/create template/create survey
          const syncCommand = new PlatformCommand('SyncFrozenFieldsCommand', 'DataSurveyApi');
          syncCommand.fieldValues['SurveyId'] = params.surveyId;
          this.commandService.executePlatformCommand(syncCommand).pipe(take(1)).subscribe(state => {
            this.createDataSurveyBreadcrumbs();
            this.surveyId = params.surveyId;
            this.flowChartDataService.surveyId = this.surveyId;
            this.getCurrentSurvey(); // get survey obj by id.read from reducer
            this.isReady = true;
          });

        }
      });
    }

    this.dataSurveyStore.pipe(takeUntil(this.ngUnsubscribe), select(getCurrentSurvey)).subscribe(currentSurvey => {
      this.survey = currentSurvey;
      if (this.survey && this.survey.id && this.surveyId === this.survey.id) {
        const found = this.breadcrumbs.find((x: any) => x.id === this.surveyId);
        if (!found) {
          this.breadcrumbs.push(<BreadcrumbModel>{
            id: this.survey.id,
            title: this.survey.title,
            type: 'DataSurvey',
            relativeUrl: 'data-survey/templates/' + this.survey.id + '/edit'
          });
        } else {
          return;
        }
        if (this.isResponseView) {
          this.fetchFlowChartResponse();
        } else {
          this.fetchDesignerAllTopics();
        }
      }

    });
    console.log('>>>>>>>>>>' + this.flowChartDataService.invalidateSubject.invalidateSubjectIdentityKey);
    this.flowChartDataService.getInvalidateSubjectObservable().pipe(takeUntil(this.ngUnsubscribe)).subscribe((refreshType: any) => {
      console.log('>>>>>>>>>>' + this.flowChartDataService.invalidateSubject.invalidateSubjectIdentityKey);
      this.fetchDesignerAllTopics();
    });
  }

  private createDataSurveyBreadcrumbs() {
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'DataSurvey',
        title: 'Data Surveys',
        type: 'DataSurvey',
        relativeUrl: 'data-survey'
      },
      <BreadcrumbModel>{
        id: 'ManageTemplate',
        title: 'Templates',
        type: 'DataSurvey',
        relativeUrl: 'data-survey/templates'
      }
    ];
  }

  toggle() {
    this.fuseSplashScreenService.show();
    const command = new SyncFieldsInDataSurveyCommand(this.surveyId);
    this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandState => {
        this.flowChartDataService.excludeHiddenQuestions = !this.flowChartDataService.excludeHiddenQuestions;
        this.fetchDesignerAllTopics();
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('SyncQuestionCommand error ', error);
      }
    );

  }

  onTabIndexChange(event) {
    if (this.currentRightSideComponentInfo && this.currentRightSideComponentInfo.component === 'ViewDetailComponent') {
      this.closeRightSidebar();
    }
    this.platformSidebarService.hideSidebarIcon('Details & Instructions');
    this.selectedTabIndex = event;
    this.flowChartId = this.flowcharts[this.selectedTabIndex].id;
    this.flowChartDataService.setFlowchartId(this.flowChartId);
    this.sourceType = this.flowcharts[this.selectedTabIndex].sourceType;
    this.toolHeader = this.flowcharts[this.selectedTabIndex].toolHeader;
    this.flowChartDataService.setSourceType(this.sourceType);
    this.flowChartDataService.setToolHeader(this.toolHeader);
    this.flowChartDataService.fetchCustomDataTypes(this.sourceType);

    this.getSections();
  }

  closeRightSidebar() {
    if (this.sidebarService.getSidebar('rightsidebar')) {
      this.sidebarService.getSidebar('rightsidebar').close();
      this.sidebarService.getSidebar('rightsidebar').fold();
    }
    this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction(null));
    this.platformSidebarStore.dispatch(new SetCurrentRightSideBarFoldOrNotAction(true));
  }

  getSections() {
    if (this.flowChartMode === 'design') {
      this.flowChartDataService.getDesignerSingleTopicSections().then(
        data => {
          this.sections = data[0];
        }
        ,
        error => {
          console.error('getDesignerSingleTopicSections error', error);
        }
      );
    } else if (this.flowChartMode === 'response') {
      this.getFlowchartResponseSections();
    }
  }

  fetchDesignerAllTopics() {
    const query: any = {};
    query.includeFlowChartsInfo = true;
    query.includeFirstFlowchart = true;
    query.includeAllFlowcharts = true;
    this.fuseSplashScreenService.show();
    this.flowChartDataService.getFlowChartInfoByQueryObj(query).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data => {
        this.fuseSplashScreenService.hide();
        console.log('get flow chart tab info', data);
        this.flowChartMode = 'design';
        this.flowcharts = data.flowcharts;
        this.flowchartSections = data.flowchartSections;
        if (data.flowchartSections && data.flowchartSections[this.flowcharts[this.selectedTabIndex].id]) {
          this.sections = data.flowchartSections[this.flowcharts[this.selectedTabIndex].id];
        }
      }
      ,
      error => {
        this.fuseSplashScreenService.hide();
        console.error('get flow chart tab info error ', error);
      }
    );
  }

  fetchFlowChartResponse() {
    const query: any = {};
    // this.surveyId  = this.survey.id;
    query.surveyId = this.survey.id;
    query.createPreviewItem = true;
    query.includeFlowChartsInfo = true;
    query.includeFirstFlowchart = true;
    query.includeAllFlowcharts = true;
    if (this.isResponseView) {
      query.itemId = this.itemId;
      query.createPreviewItem = false;
      if (this.flowChartId) {
        query.includeAllFlowcharts = false;
        query.includeFlowChartsInfo = true;
        query.includeFirstFlowchart = false;
        query.includeSelectedFlowchart = [this.flowChartId];
      }
    }

    this.fuseSplashScreenService.show();
    this.flowChartDataService.getFlowChartResponseInfoByQueryObj(query).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data => {
        this.fuseSplashScreenService.hide();
        console.log('get flow chart tab info', data);
        this.flowChartMode = 'response';
        this.rowItem = data.row;
        this.fieldDefinitions = data.fieldDefinitions;
        this.flowcharts = data.flowcharts;
        this.flowchartSections = data.flowchartSections;
        this.flowChartDataService.setFieldVisibility(data.fieldVisibilities);
        if (data.flowchartSections && data.flowchartSections[this.flowcharts[this.selectedTabIndex].id]) {
          this.sections = data.flowchartSections[this.flowcharts[this.selectedTabIndex].id];
        }
      }
      ,
      error => {
        this.fuseSplashScreenService.hide();
        console.error('get flow chart tab info error ', error);
      }
    );
  }


  getFlowchartResponseSections() {
    if (this.surveyId && this.flowChartId) {
      const query: any = {};
      query.surveyId = this.surveyId;
      query.includeFlowChartsInfo = false;
      query.includeFirstFlowchart = false;
      query.includeSelectedFlowchart = [this.flowChartId];
      query.createPreviewItem = true;
      if (this.isResponseView) {
        query.itemId = this.itemId;
        query.createPreviewItem = false;
      }
      this.fuseSplashScreenService.show();
      this.flowChartDataService.getFlowChartResponseInfoByQueryObj(query).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        data => {
          this.fuseSplashScreenService.hide();
          console.log('flowchart get sections', data);
          this.rowItem = data.row;
          this.fieldDefinitions = data.fieldDefinitions;
          this.flowChartDataService.setFieldVisibility(data.fieldVisibilities);
          if (data.flowchartSections && data.flowchartSections[this.flowChartId]) {
            this.sections = data.flowchartSections[this.flowChartId];
          }
        },
        error => {
          this.fuseSplashScreenService.hide();
          console.error('flowchart get sections error', error);
        }
      );
    }
  }

  ngOnDestroy() {
    this.flowChartDataService.destroy();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getCurrentSurvey() {
    this.dataSurveyStore.dispatch(new GetSurveyAction(this.surveyId));
  }

  startExecution() {
    this.router.navigateByUrl(`data-survey/${this.surveyId}/edit`);
  }

  showPreview() {
    this.selectedTabIndex = 0;
    this.fetchFlowChartResponse();
  }

  showDisigner() {
    this.selectedTabIndex = 0;
    this.fetchDesignerAllTopics();
  }

  toggleView() {
    this.closeRightSidebar();
    if (this.flowChartMode === 'design') {
      this.showPreview();
    } else {
      this.showDisigner();
    }
  }

  renameTopic(flowchart: any) {
    const self = this;
    const dialogModel: DialogModel = DialogModel.create(
      'Rename Topic',
      'RenameTitleDialogComponent', {
        fieldName: 'Topic Name', name: flowchart.toolHeader
      },
      '765px',
      '765px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res.action === 'OK' && flowchart.toolHeader !== res.data.input.name) {
        this.flowChartDataService.renameTopicCommandExecute(flowchart, res);
      }
    });
  }

  deleteTopic(data: any) {
    const message = 'Any existing questions in this topic will also be removed.';
    const question = 'Are you sure you want to remove this topic?';
    this.dialogService.showConfirmDialog('Remove Topic', 'Delete', 'Cancel', message, question ).subscribe(dialogState => {
      if (dialogState.action === 'OK') {
        this.flowChartDataService.deleteTopicCommandExecute(data);
      }
    });
  }

  addTopic() {
    const dialogModel: DialogModel = DialogModel.create(
      'Add Topic',
      'AddTopicDialogComponent', {topicSource: 'Custom', surveyId: this.surveyId},
      '765px',
      '765px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res.action === 'OK') {
        this.flowChartDataService.addTopicCommandExecute(res);

      }
    });
  }

  moveTopic(direction: string) {
    if (direction === 'left') {

    } else {
    }

  }

  afterExecuteCommand($event: any) {
    console.log('afterExecuteCommand', $event);
    if ($event.response.fieldValues['ExcludeHiddenQuestions'] === true || $event.response.fieldValues['ExcludeHiddenQuestions'] === false) {
       this.invalidateExcludeHiddenQuestions($event.response.fieldValues['ExcludeHiddenQuestions']);
    }
  }
  invalidateExcludeHiddenQuestions(excludeHiddenQuestions: boolean) {
    this.flowChartDataService.excludeHiddenQuestions = excludeHiddenQuestions;
    this.fetchDesignerAllTopics();
  }

  editDetailsAndInstructions() {
    if (this.isManageFields) {
      this.detailsInstructionService.openDetailsInstructionPopUp(InstructionDetailsSourceViewType.flowchart, this.sourceType);
    } else {
      this.detailsInstructionService.openDetailsInstructionPopUp(InstructionDetailsSourceViewType.flowchart, this.surveyId,'',null,null,this.surveyId);
    }
  }
}
